import { storefrontDeliveryEstimateSchema } from "@redotech/redo-conversion-core-common/conversion/storefront-delivery-estimate";
import * as z from "zod";

export const getStorefrontDeliveryEstimateSettings = {
  name: "getStorefrontDeliveryEstimateSettings" as const,
  input: z.null(),
  output: z.object({ settings: storefrontDeliveryEstimateSchema.optional() }),
};
